import axiosInstance from "utils/axios-request";
import {gatewayUrl} from "config";
import {ILoanBoundary} from "IncompleteInfoV2/LoanRequest/utils";

export interface ILoanRequest {
    applicationId: number;
    amountRequested: number;
    tenureRequested: number;
    purpose: string;
}

export const getFinancialDetails = async (productCode: string): Promise<{loanBoundary: ILoanBoundary}> => {
    const response = await axiosInstance.request({
        baseURL: gatewayUrl,
        url: "/corleone/loan-boundary",
        method: "get",
        params: {productCode},
    });
    return response.data;
};

export const updateLoanRequirement = async (loanRequest: ILoanRequest): Promise<{data: string, status: number}> =>
    await axiosInstance.request({
        baseURL: gatewayUrl,
        url: `/loan-application/loan-requirement`,
        method: "post",
        data: loanRequest,
    });